import React from 'react'
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

import {ThemeProvider} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        }
    },
});

const useStyles = makeStyles((theme) => ({
    marginBox: {
        width: '92%',
        maxWidth: '600px',
        paddingLeft: '20px',
        marginLeft: '-8px',
        marginTop: '2px'
    },
    textBox: {
        width: '90%',
        display: 'inline-block',
    }
}));

const FileLoaded = ({files, file, setFiles}) => {
    const classes = useStyles();

    const deleteFile = (file) => {

        let response = files.filter(singleFile => singleFile.name !== file)

        setFiles(response)
    }

    return (
        <Container maxWidth="sm">
            <ThemeProvider theme={theme}>
                <Paper
                    elevation={3}
                    className={classes.marginBox}
                    variant="outlined"
                >
                    <p className={classes.textBox}>{file.name}</p>
                    <HighlightOffIcon
                        onClick={()=>deleteFile(file.name)}
                    />
                </Paper>
            </ThemeProvider>
        </Container>
    )
}

export default FileLoaded
